import { useStore } from "@priolo/jon"
import ExportDialog from "components/controls/ExportDialog"
import VerticalPage from "components/controls/page/VerticalPage"
import { FunctionComponent } from "react"
import cycleSo from "stores/cycle"
import draftSo from "stores/draft"
import incidentSo from "stores/incidents"
import { loadAll } from "stores/planner/utils/fetch"
import { PAGE_ID } from "stores/route/utils/types"
import { useInitFarmPage } from "../useInitFarmPage"
import CyclesTable from "./CyclesTable"
import DetailDialog from "./detail/DetailDialog"



const CycleTablePag: FunctionComponent = () => {

	// STORE
	useStore(draftSo)
	useStore(cycleSo)

	// HOOKs
	useInitFarmPage(PAGE_ID.FARM_CYCLES, null, async (farm) => {
		// carico tutto il necessario tra CYCLE e TASK e ALERT
		await loadAll(farm.id)
		// in asincrono carico pure gli INCIDENTS e PHOTOS
		//incidentSo.fetchAllIfVoid(farm.id)
		//querySo.updateQueryUrl()
	})

	// HANDLERS
	const handleExportClose = () => cycleSo.setIsCsvExportOpen(false)

	// RENDER
	return <VerticalPage width={1360}>
		<CyclesTable />
		<DetailDialog />
		<ExportDialog
			isOpen={cycleSo.state.isCsvExportOpen}
			onClose={handleExportClose}
			onInitData={cycleSo.getExportData}
		/>
	</VerticalPage>
}

export default CycleTablePag
